
const English = {
    "form.isRequired": "{name} is required!",
    "form.OTPLabel": "Email Verification Code",
    "form.OTPInputValidMessage": "Successful",
    "form.OTPInputInvalidMessage": "Wrong OTP",
    "form.OTPWaitSecondsLabel": "Send Again ({waitOtpSeconds}s)",
    "form.OTPSendLabel": "Send OTP",
    "form.OTPSendSuccessLabel": "Send the verification code to your email successfully!",
    "form.OTPTips": "Please enter a valid OTP.",
    "form.selectInputLabel": "Search...",
    "form.uploadBtn": "UPLOAD",
    "form.uploadSizeTips": "Files must be less than 5MB.",
    "form.uploadTypeTips": "Allowed file types: png gif jpg jpeg pdf.",
    "form.uploadNumTips": "Must be upload a file.",
    "form.isRequiredAccept": "You must accept this to proceed.",
    "form.sendButton": "SEND",
    "form.isEmail": "Please enter a valid email account",
    "form.isSerialNumber": "Please put 13 characters into {name}.",
    "form.categoryPlaceholder": "- Select product category -",
    "form.seriesPlaceholder": "- Select product series -",
    "form.skuPlaceholder": "- Model No.(SKU) -",
    "form.sendSuccessMsg": "Send Success!",

    "eventForm.submitButton": 'Register',

    "warrantyPeriod.checkTitle": "Check Warranty Status",
    "warrantyPeriod.checkDescription": "Please enter your email and serial number to check your product warranty status.",
    "warrantyPeriod.emailLabel": "Email",
    "warrantyPeriod.emailPlaceholder": "Enter Email",
    "warrantyPeriod.serialNumberLabel": "Serial Number",
    "warrantyPeriod.serialNumberPlaceholder": "Enter Serial Number",
    "warrantyPeriod.checkButton": "Check",
    "warrantyPeriod.sendSuccessfulLabel": "An email has been successfully sent to the provided email address. Please check your inbox.",
    "warrantyPeriod.checkNoRecordLabel": "Sorry, no record was found!",
}
export {
    English
}   